import React, {useState, useEffect} from 'react';
import {Autocomplete, TextField, Paper, Stack, Box, FormControl, InputLabel, Select, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, IconButton} from '@mui/material';
import FlagIcon from '@mui/icons-material/Flag';
import EditIcon from '@mui/icons-material/Edit';
import {CustomAvatar, ConfirmDialog} from  './general';
import {getUsers, doBlockUser, doUnBlockUser, doFlag, doUnFlag} from '../services/user.js';

import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import {removeUserAction} from '../actions/profile.js';
import FlagConfirmation from '../components/flagConfirmation.js';
import { getStore} from '../util';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {SnackBar} from  '../components/general.js';
import EditUser from './editUser.js'


const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

    const getMobileStyle = (status) => {
      let style = {margin: 0}
      if (status==='APPROVED') {
        style.border = '2px solid #228B22';
        style.filter = `drop-shadow(0 0 0.5rem #228B22)`;
        return style
      } else {
        style.border = '2px solid #D2042D';
        style.filter = `drop-shadow(0 0 0.5rem #D2042D)`;
        return style
      }

    }
const classes = {
  root: {
    width: '100%',
    position:'relative'
  },
  container: {
    maxHeight: '65vh',
  },
  pagination : {
    position: 'absolute',
    bottom:0,
    right:0
  },
  productInfoCont: {
      width: '100%',
      display: 'flex',
      marginBottom: '20px',
      paddingLeft: '10px'
  },
  productInfoLeft: {
    width: '30%'
  },
  productInfoRight : {
    width: '70%'
  },
  actionBtn: {
    marginLeft: '10px',
    cursor: 'pointer'
  },
  buttonCont: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  }
};

const UserSearch = ({isMobile, users, searchKey, setSearchKey}) => {
  return (
    <Autocomplete
      disablePortal
      freeSolo
      id="combo-box-demo"
      value={searchKey}
      getOptionLabel={(option) => { if (typeof option === "string"){ return option } return option?.user?.name}} // Used for display
      filterOptions={(opts, { inputValue }) =>
        opts.filter((opt) => {
          const search = inputValue.toLowerCase();
          return (
            opt.user.name.toLowerCase().includes(search) ||
            opt.user.contactNumber.includes(search)
          );
        })
      }
      onChange={(e, v)=> {
        if (v !== null) { 
          if (typeof v === "string") {
            setSearchKey(v)
          } else {
            setSearchKey(v.user.name)
          }
        } else {
          setSearchKey("")
        }
      }}
      options={users}
      sx={{ width: isMobile? '45%' : 300 }}
      renderInput={(params) => <TextField {...params} label="Search User" />}
    />
  )
}

const UserTypeSelect = ({isMobile, selectedType, setSelectedType}) => {

  const handleChange = (event) => {
    setSelectedType(event.target.value);
  };

  return (
      <FormControl sx={{width:isMobile? '45%': 200, ml: 3}}>
        <InputLabel id="demo-simple-select-label">Status</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedType}
          label="Status"
          onChange={handleChange}
        >
          <MenuItem value='all'>All</MenuItem>
          <MenuItem value='requested'>Requested</MenuItem>
          <MenuItem value='approved'>Approved</MenuItem>
          <MenuItem value='flagged'>Flagged</MenuItem>
          <MenuItem value='declined'>Declined</MenuItem>
        </Select>
      </FormControl>
  );
}

const PhoneRow = ({isMobile, phone}) => {

  const openWhatsapp = (e) => {
    e.stopPropagation();
    const url = `https://wa.me/+91${phone}`;
    window.open(url, '_blank');
  }

  const openDialer = (e) => {
    e.stopPropagation();
    const url = `tel:${phone}`;
    window.open(url, '_blank');
  }

  if (isMobile) {
    return (<TableCell align={'center'}>
      <Stack direction="row">
        <IconButton sx={{mr: 1}} onClick={openWhatsapp}><WhatsAppIcon/></IconButton>
        <IconButton onClick={openDialer}><CallIcon/></IconButton>
      </Stack>
    </TableCell>)
  }
  return (<TableCell align={'center'}>{phone} </TableCell>)

}

export default function StickyHeadTable(props) {

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [users, setUsers] = React.useState([]);
  const [flagConfirmOpen, setFlagConfirmOpen] = useState(false)
  const [flagReason, setFlagReason] = useState('')
  const [userToFlag, setUserToFlag] = useState();
  const [userToUnFlag, setUserToUnflag] = useState(); 
  const [unflagConfirmOpen, setUnflagConfirmOpen] = useState(false)
  const [showSnack, setShowSnack] = useState(false)
  const [snackMessage, setSnackMessage] = useState('')
  const [snackType, setSnackType] = useState('success')
  const [selectedType, setSelectedType] = useState('all');
  const [searchKey, setSearchKey] = useState('');
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [showEdit, setShowEdit] = useState(false);
  const [selectedUser, setSelectedUser] = useState()

    const isMobile = windowDimensions.width < 500 ? true : false

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const headers = isMobile ? 
    [
      {label:'', minWidth:20},
      {label:'Name', minWidth:170},
      {label:'Phone', minWidth:150},
      {label:'Actions', minWidth:150},
      ]
    :
    [
      {label:'', minWidth:20},
      {label:'Name', minWidth:170},
      {label:'Status', minWidth:150},
      {label:'Phone', minWidth:150},
      {label:'Actions', minWidth:150},
      ]

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  

    const filterByType = (type) => {
      const userStatusMap = {
          'approved': 'APPROVED',
          'declined': 'DECLINED',
          'flagged': 'FLAGGED',
          'requested': 'REQUESTED'
      }
      
      return (user) => {
          if (type=== 'all') {
              return true
          }
          return user.status === userStatusMap[type]
      }
  }

  const searchUser = (key) => {
    return (user) => {
      if (key) {
        if (user?.user?.name) {
          return user?.user?.name.toLowerCase().includes(key.toLowerCase()) || user?.user?.contactNumber.includes(key)
        }
        return false
      }
      return true
    } 
  }

  const handleEditClick = (id) => {
    return (e) => {
        console.log(e.target.parent)
      const _user = users.find(user => user.userId === id);
        console.log(_user)
      props.setViewUser(_user);
    }
  }
   
  const flag = async() => {
      try {
          await doFlag(userToFlag, flagReason)
          setUserToFlag();
          const _users = [...users];
          const _user = _users.find(x=>x.userId === userToFlag)
          _user.status = 'FLAGGED';
          _user.reason = flagReason;
          setUsers(_users)
          setFlagConfirmOpen(false)
          setShowSnack(true)
          setSnackMessage('User has been flagged')
          setSnackType('success')
      } catch (e) {
          console.log(e)
          if (e.status === 401) {
            dispatch(removeUserAction())
            navigate('/');
          }
          setShowSnack(true)
          setSnackMessage('Error in flagging user')
          setSnackType('error')
      }
  }
    const unflag = async () => {
        try {
            await doUnFlag(userToUnFlag)
            setUserToUnflag();
            const _users = [...users];
            const _user = _users.find(x=>x.userId === userToUnFlag)
            _user.status = 'APPROVED';
            delete _user.reason;
            setShowSnack(true)
            setSnackMessage('User has been unflagged')
            setSnackType('success')
            setUsers(_users)
            setUnflagConfirmOpen(false)
        } catch (e) {
            console.log(e)
            if (e.status === 401) {
              dispatch(removeUserAction())
              navigate('/');
            }
            setShowSnack(true)
            setSnackMessage('Error in unflagging user')
            setSnackType('error')
        }

    }
    const handleUnflagConfirmClose = () => {
        setUserToUnflag();
        setUnflagConfirmOpen(false)
    }

    const handleFlagConfirmClose = () => {
        setUserToFlag();
        setFlagConfirmOpen(false)
    };

    const handleFlagClick = (row) => {
        return (e) => {
            e.stopPropagation();
            if (row.status === 'APPROVED') {
                setUserToFlag(row.userId);
                setFlagConfirmOpen(true )
            }
            if (row.status === 'FLAGGED') {
                setUserToUnflag(row.userId)
                setUnflagConfirmOpen(true )
            }
        }
    }
    const refreshUsers = async() => {
        try {
          const _users = await getUsers(props.selectedProduct);
          setUsers(_users);
        } catch (e) {
          if (e.status === 401) {
            dispatch(removeUserAction())
            navigate('/');
          }
        }
      }
  React.useEffect(()=>{
      refreshUsers();
     
  },[props.usersChange])

  const loggedinStore = getStore('user')?.user?.store ?? '';
  console.log(showEdit)
  
  return (
    <Paper sx={classes.root}>
      <Stack direction="row" sx={{margin: 1, padding: 1}}>
        <UserSearch isMobile={isMobile} searchKey={searchKey} setSearchKey={setSearchKey} users={users.filter(filterByType(selectedType))}/>
        <UserTypeSelect isMobile={isMobile} selectedType={selectedType} setSelectedType={setSelectedType}/>
      </Stack>
      <TableContainer sx={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {headers.map((column) => (
                <TableCell
                  key={column._id}
                  align={'center'}
                  style={{ width: column.minWidth, fontWeight:600 }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {users.filter(filterByType(selectedType)).filter(searchUser(searchKey)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, ind) => {
                let flagColor;
                if (row.status === 'APPROVED') {
                    flagColor ='red'
                }
                if (row.status === 'FLAGGED') {
                    flagColor = 'green'
                }
              return (
                <TableRow hover onClick={handleEditClick(row.userId)} tabIndex={-1} key={row.sku}>
                  <TableCell align={'center'}> <CustomAvatar style={isMobile ? getMobileStyle(row.status) : {}}  src={row?.user?.image?.thumb??''} name={row?.user?.name}/></TableCell>
                <TableCell align={'center'}> {row?.user?.name}</TableCell>
                {!isMobile && (<TableCell align={'center'} style={row.status === 'APPROVED'?{fontWeight:'bold', color:'#228B22'} : {fontWeight:'bold', color:'#D2042D'}}> {row.status}</TableCell>)}
                <PhoneRow isMobile={isMobile} phone={row?.user?.contactNumber}/>
                <TableCell align={'center'}>
                  <Stack direction="row" alignItems="center" justifyContent="center">
                    {(row.status === 'APPROVED' || row.status === 'FLAGGED') && <IconButton onClick={handleFlagClick(row)}>
                      <FlagIcon style={{color:flagColor}}/>
                    </IconButton>}
                    {row?.user?.trustedStore._id === loggedinStore && (<IconButton onClick={(e)=>{e.stopPropagation(); setSelectedUser(row); setShowEdit(true);}}><EditIcon/></IconButton>)}
                  </Stack>
                </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        classes={classes.pagination}
        count={users.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <FlagConfirmation
        flagConfirmOpen={flagConfirmOpen}
        handleClose={handleFlagConfirmClose}
        flagReason={flagReason}
        setFlagReason={setFlagReason}
        doFlag={flag}
      />
      <ConfirmDialog
        title={'Are you sure ?'}
        message={'Are you sure to unflag this user?'}
        confirmAction={unflag}
        show={unflagConfirmOpen}
        handleClose={handleUnflagConfirmClose}
      />
      {showEdit && (<EditUser
        open={showEdit}
        setOpen={setShowEdit}
        selectedUser={selectedUser}
        setUsersChange={()=>{
            setShowSnack(true)
            setSnackMessage("User Edited successfully")
            setSnackType("success")
            refreshUsers()
        }}
      />)}
      <SnackBar severity={snackType} message={snackMessage} open={showSnack} handleClose={()=>{setShowSnack(false)}}/>
    </Paper>
  );
}

